module.exports = __webpack_public_path__ + "ic_image_24px.svg?b096f0da76cb90cda6463183c7383f10";